import * as yup from 'yup';

const hexColorRegex = /^#+([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/gi;

export const colorSchema: yup.StringSchema = yup.string().matches(hexColorRegex);
